<div class="text-center" >

    <button class="close" mat-button (click)="onNoClick()"><i class="fa fa-times"></i></button>
<div class="text-center">
<!--<img src="{{getImageURL()}}" style="width: 100%">-->
    <lib-ngx-image-zoom
                        [thumbImage]="getImageURL()"
                        [magnification]="0"

                        [enableScrollZoom]="false"
                        [enableLens]="true"
    ></lib-ngx-image-zoom>
</div>
</div>
